import React, { Fragment } from 'react'
import { Link } from 'gatsby'

import Layout from '../components/Layout'
import { SignUpForm } from '../components/Authentication'
import * as ROUTES from '../constants/routes'

const SignUpPage = () => (
    <Fragment>
        <h1>SignUp</h1>
        <SignUpForm />I have an account:
        <Link to={ROUTES.SIGN_IN}>Sign in</Link>
    </Fragment>
)

export default ({ location }) => (
    <Layout location={location}>
        <SignUpPage />
    </Layout>
)
